import React from "react";
var __jsx = React.createElement;
import { useState, useRef, useEffect, Fragment } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import Camera360New from "../camera360New/Camera360New";
import stl from "./NewPostBigSlider.module.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import CarImage from "@componentsShared/CarImage";
import { useLang } from "@/common/Contexts/LanguageContext";
import useIsMobile from "@hooks/useIsMobile";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var NewPostBigSlider = function NewPostBigSlider(props) {
  var _props$children, _props$inpectionNote$;
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  var sliderRef = useRef(null);
  var thumbRef = useRef(null);
  var _useState = useState(0),
    Tab = _useState[0],
    setTab = _useState[1];
  var _useState2 = useState(((props === null || props === void 0 ? void 0 : props.children) || []).slice(0, 50)),
    imagesSlides = _useState2[0],
    setImagesSlides = _useState2[1];
  var _useState3 = useState(0),
    selectedIndex = _useState3[0],
    setSelectedIndex = _useState3[1];
  var _useState4 = useState(0),
    maxIteration = _useState4[0],
    setMaxIteration = _useState4[1];
  var _useState5 = useState(undefined),
    videoObject = _useState5[0],
    setVideoObject = _useState5[1];
  var _useState6 = useState(!!props.openInFull),
    bigGallery = _useState6[0],
    setBigGallery = _useState6[1];
  var _useState7 = useState(false),
    has360Flag = _useState7[0],
    setHas360Flag = _useState7[1];
  var _useState8 = useState(false),
    showVideo = _useState8[0],
    setShowVideo = _useState8[1];
  var _useState9 = useState(true),
    Loader = _useState9[0],
    setLoader = _useState9[1];
  var _useState0 = useState(false),
    TabChangeLoader = _useState0[0],
    setTabChangeLoader = _useState0[1];
  var _useState1 = useState(0),
    Movment = _useState1[0],
    setMovment = _useState1[1];
  var _useState10 = useState(0),
    NumberOfFingers = _useState10[0],
    setNumberOfFingers = _useState10[1];
  var lang = useLang();
  useEffect(function () {
    props.updateActiveIndex && props.updateActiveIndex(selectedIndex);
  }, [selectedIndex]);
  useEffect(function () {
    if (props.openInFull) {
      setBigGallery(true);
      document.body.style.overflow = "hidden";
    }
  }, [props.openInFull]);
  useEffect(function () {
    setImagesSlides((props === null || props === void 0 ? void 0 : props.children) || []);
    ExtractVideo();
    setTimeout(function () {
      setLoader(false);
    }, 2000);
  }, [props === null || props === void 0 ? void 0 : (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.length]);
  useEffect(function () {
    ExtractVideo();
    props.getAllImages && CheckAllImages();
  }, [imagesSlides === null || imagesSlides === void 0 ? void 0 : imagesSlides.length]);
  useEffect(function () {
    setTimeout(function () {
      setTabChangeLoader(false);
    }, 3000);
  }, [Tab]);
  useEffect(function () {
    CheckAllImages();
    if (bigGallery) {
      var flippingFactor = document.querySelector("body").attributes.dir.value != "ltr" ? -1 : 1;
      if (window.innerWidth <= 1024) {
        thumbRef.current.scrollTo({
          left: flippingFactor * (selectedIndex - 1) * 114 - 120,
          behavior: "smooth"
        });
      } else {
        thumbRef.current.scrollTo({
          left: flippingFactor * (selectedIndex - 1) * 152,
          behavior: "smooth"
        });
      }
    }
  }, [selectedIndex]);
  var ExtractVideo = function ExtractVideo() {
    if (props.video) {
      var videoItem = props.video;
      setVideoObject(videoItem);
    }
  };
  var setHas360 = function setHas360(val) {
    setHas360Flag(val);
  };
  var SlideImage = function SlideImage(nextOrPrev) {
    if (nextOrPrev === "prev") {
      selectedIndex === 0 ? setSelectedIndex(imagesSlides.length - 1) : setSelectedIndex(selectedIndex - 1);
    }
    if (nextOrPrev === "next") {
      selectedIndex === imagesSlides.length - 1 ? setSelectedIndex(0) : setSelectedIndex(selectedIndex + 1);
    }
  };
  var CheckAllImages = function CheckAllImages() {
    maxIteration == 0 && setMaxIteration(imagesSlides.length);
  };
  var RenderVideoBasedOnUrl = function RenderVideoBasedOnUrl(url) {
    return /*#__PURE__*/React.createElement("div", {
      className: stl.videoPopUp
    }, /*#__PURE__*/React.createElement("div", {
      className: [stl.singleItem, stl.videoSingleItem].join(" ")
    }, url.indexOf("youtu") > -1 ? /*#__PURE__*/React.createElement("div", {
      className: "videoWrapper"
    }, /*#__PURE__*/React.createElement("iframe", {
      width: "100%",
      height: "100%",
      src: url + "?rel=0&amp;autoplay=1&amp;mute=1",
      title: "YouTube video player",
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: ""
    })) : /*#__PURE__*/React.createElement("video", {
      controls: true,
      autoplay: true,
      muted: true,
      playsinline: true,
      src: url,
      type: "video/mp4"
    }, /*#__PURE__*/React.createElement("source", {
      src: url,
      type: "video/mp4"
    }))));
  };
  var GetFinalMovment = function GetFinalMovment() {
    var flippingFactor = 1;
    lang === "en" ? flippingFactor = -1 : 1;
    return selectedIndex * 100 * flippingFactor;
  };

  // touchEvents
  var _useState11 = useState(null),
    xDown = _useState11[0],
    setXDown = _useState11[1];
  var _useState12 = useState(null),
    yDown = _useState12[0],
    setYDown = _useState12[1];
  var getTouches = function getTouches(evt) {
    return evt.touches || evt.originalEvent.touches;
  };
  function handleTouchStart(evt) {
    setNumberOfFingers(evt.touches.length);
    sliderRef.current.style.transition = "0s";
    var firstTouch = getTouches(evt)[0];
    setXDown(firstTouch.clientX);
    setYDown(firstTouch.clientY);
  }
  var handleTouchSwipe = function handleTouchSwipe(evt) {
    if (NumberOfFingers === 1) {
      if (!xDown || !yDown) {
        return;
      }
      setMovment(evt.touches[0].clientX - xDown);
      CheckAllImages();
      var flippingFactor = 1;
      lang === "en" ? flippingFactor = -1 : 1;
      var currentleft = window.innerWidth * selectedIndex * flippingFactor;

      // sliderRef.current.style.left =
      //   currentleft + evt.touches[0].clientX - xDown + "px";
    }
  };
  var handleTouchEnd = function handleTouchEnd(evt) {
    /*most significant*/
    if (NumberOfFingers === 1) {
      sliderRef.current.style.transition = "";
      // sliderRef.current.style.left = GetFinalMovment() + "%";

      if (Movment > 70 || Movment < -70) {
        var b = document.querySelector("body");
        if (Movment < 0) {
          lang === "ar" ? SlideImage("prev") : SlideImage("next");
        } else {
          lang === "ar" ? SlideImage("next") : SlideImage("prev");
        }
      }
    }
    /* reset values */
    setXDown(null);
    setYDown(null);
    setNumberOfFingers(0);
    setMovment(0);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, bigGallery ? stl.bigGallShow : undefined, props !== null && props !== void 0 && props.hasCampaign || bigGallery ? stl.noRad : undefined].join(" "),
    id: "post-image-slider-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.mobileControls,
    id: "slider-mobile-controls"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    onClick: function onClick(e) {
      if (props.onClose) {
        props.onClose(e);
      } else {
        setBigGallery(false);
        document.body.style.overflow = "";
        setTab(0);
        setTabChangeLoader(true);
        setShowVideo(false);
      }
    },
    className: "hasEvents applyWebVevent",
    src: CDN_LINK + "/assets/images/whitearrowBack.svg",
    alt: "Close gallery",
    width: 24,
    height: 24
  }), props.inpectionTitle && /*#__PURE__*/React.createElement("strong", {
    className: stl.inpectionTitle
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    tabIndex: 0,
    onClick: function onClick() {
      if (props.onClose) {
        props.onClose();
      } else {
        setBigGallery(false);
        document.body.style.overflow = "";
        setTab(0);
        setTabChangeLoader(true);
        setShowVideo(false);
      }
    }
  }, props.inpectionTitle))), !props.isInpectionBlack && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setTab(0);
      setTabChangeLoader(true);
    },
    className: [
    // stl.singleTab,
    // Tab == 0 ? stl.active : undefined,
    Tab == 0 ? stl.mobileActiveTB : undefined].join(" ")
  }, Tab == 0 ? /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/ImagesBWhite.svg",
    alt: "images",
    width: 16,
    height: 16
  }) : /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/ImagesBBlue.svg",
    alt: "images",
    width: 24,
    height: 24
  })), (props === null || props === void 0 ? void 0 : props.showCamera360) && (props === null || props === void 0 ? void 0 : props.id360) && /*#__PURE__*/React.createElement("div", {
    id: "hideBtnNo360Mobile",
    onClick: function onClick() {
      setTab(1);
      setTabChangeLoader(true);
    },
    className: [
    // stl.singleTab,
    // Tab == 1 ? stl.active : undefined,
    Tab == 1 ? stl.mobileActiveTB : undefined].join(" ")
  }, Tab == 1 ? /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/360BWhite.svg",
    alt: "images"
  }) : /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/360BBlue.svg",
    alt: "images"
  })), props.video && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setTab(2);
      setTabChangeLoader(true);
      setShowVideo(true);
    },
    className: [
    // stl.singleTab,
    // Tab == 2 ? stl.active : undefined,
    Tab == 2 ? stl.mobileActiveTB : undefined].join(" ")
  }, Tab == 2 ? /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/PlayBWhite.svg",
    alt: "images"
  }) : /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/PlayBBlue.svg",
    alt: "images"
  })))), /*#__PURE__*/React.createElement("div", {
    className: [stl.headingSection, "m-hide", props.isInpectionBlack ? stl.blackHEad : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.upperSection].join(" ")
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "hasEvents",
    tabIndex: 0,
    onClick: function onClick(e) {
      if (props.onClose) {
        props.onClose(e);
      } else {
        setBigGallery(false);
        document.body.style.overflow = "";
        setTab(0);
        setTabChangeLoader(true);
        setShowVideo(false);
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: props.isInpectionBlack ? CDN_LINK + "/assets/images/closewhite.svg" : CDN_LINK + "/assets/images/closeBslider.svg"
    // width={25}
    // height={25}
    ,
    alt: "close"
  })), props.inpectionTitle && /*#__PURE__*/React.createElement("strong", {
    className: stl.inpectionTitle
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    tabIndex: 0,
    onClick: function onClick() {
      if (props.onClose) {
        props.onClose();
      } else {
        setBigGallery(false);
        document.body.style.overflow = "";
        setTab(0);
        setTabChangeLoader(true);
        setShowVideo(false);
      }
    }
  }, props.inpectionTitle)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, props.title))), /*#__PURE__*/React.createElement("div", {
    className: [stl.tabs].join(" "),
    id: "slider-tabs"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setTab(0);
      setTabChangeLoader(true);
    },
    className: [stl.singleTab, Tab == 0 ? stl.active : undefined].join(" "),
    id: "slider-tab-images"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/ImagesGGrey.svg",
    alt: "images"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/ImagesBBlue.svg",
    alt: "images"
  }), /*#__PURE__*/React.createElement("span", null, t("photos", {
    ns: "web_post_view"
  }))), (props === null || props === void 0 ? void 0 : props.showCamera360) && props.id360 && /*#__PURE__*/React.createElement("div", {
    id: "hideBtnNo360",
    onClick: function onClick() {
      setTab(1);
      setTabChangeLoader(true);
      trackEvents("view_360", helpers.getG4_data());
    },
    className: [stl.singleTab, Tab == 1 ? stl.active : undefined].join(" ")
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/360GGrey.svg",
    alt: "images"
  }), /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/360BBlue.svg",
    alt: "images"
  }), /*#__PURE__*/React.createElement("span", null, t("view_360", {
    ns: "web_post_view"
  }))), props.video && /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      setTab(2);
      setTabChangeLoader(true);
      setShowVideo(true);
      //  trackEvents("view_video",props?.postData?.g4_data)
      // viewVideoEvent(props?.postData?.g4_data);
    },
    className: [stl.singleTab, Tab == 2 ? stl.active : undefined].join(" "),
    id: "slider-tab-video"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/PlayGGrey.svg",
    alt: "images"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/PlayBBlue.svg",
    alt: "images"
  }), /*#__PURE__*/React.createElement("span", null, t("watch_video", {
    ns: "web_post_view"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: stl.bodySection
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab",
    style: {
      display: Tab != 0 ? "none" : ""
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.imagesSliderContainer, props.campaignText && !bigGallery ? stl.noRad : undefined, props !== null && props !== void 0 && props.hasCampaign || bigGallery ? stl.noRad : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    ref: sliderRef,
    onTouchStart: function onTouchStart(e) {
      e.touches.length === 1 && handleTouchStart(e);
    },
    onTouchMove: function onTouchMove(e) {
      e.touches.length === 1 && handleTouchSwipe(e);
    },
    onTouchEnd: function onTouchEnd(e) {
      handleTouchEnd(e);
    },
    className: stl.wrraper
    // style={{ left: GetFinalMovment() + "%" }}
  }, imagesSlides.slice(0, 99).map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: idx + "sliderItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: [stl.singleItem, props.campaignText && !bigGallery ? stl.noRad : undefined, !bigGallery ? stl.noRad : undefined, selectedIndex == idx ? stl.activeItem : undefined, idx === selectedIndex ? stl.activeSlide : undefined, idx === selectedIndex ? "activeSlide" : undefined, idx > selectedIndex ? stl.nextSlide : undefined, idx < selectedIndex ? stl.prevSlide : undefined, selectedIndex === (imagesSlides === null || imagesSlides === void 0 ? void 0 : imagesSlides.length) - 1 && idx === 0 ? stl.actAsLst : undefined, idx === (imagesSlides === null || imagesSlides === void 0 ? void 0 : imagesSlides.length) - 1 && selectedIndex === 0 ? stl.actAsfirst : undefined].join(" "),
      onClick: function onClick() {
        setBigGallery(true);
        window.innerWidth < 1025 && (document.body.style.overflow = "hidden");
        CheckAllImages();
      }
    }, /*#__PURE__*/React.createElement(CarImage, {
      src: bigGallery ? item.props.src.replace("x683", "x960").replace("x426", "x960") : item.props["src"],
      alt: item.props["alt"],
      loading: idx == 0 ? "eager" : "lazy",
      width: isMobile ? 430 : 720,
      height: isMobile ? undefined : 446
    })));
  })), imagesSlides.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.nextArr,
    id: "slider-next-arrow",
    onClick: function onClick() {
      // CheckAllImages();

      SlideImage("prev");
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.prevArr,
    id: "slider-prev-arrow",
    onClick: function onClick() {
      SlideImage("next");
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.enlargeNote,
    id: "enlarge-note"
  }, t("click_zoom", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: [stl.crntImgCC, ""].join(" "),
    id: "image-counter"
  }, /*#__PURE__*/React.createElement("span", null, selectedIndex + 1), /*#__PURE__*/React.createElement("span", {
    "data-dir": "rtl"
  }, "/"), /*#__PURE__*/React.createElement("span", {
    "data-dir": "ltr"
  }, "/"), /*#__PURE__*/React.createElement("span", null, imagesSlides.length)), props.showCamera360 && /*#__PURE__*/React.createElement("div", {
    className: [stl.button360, ""].join(" "),
    id: "view-360-button",
    onClick: function onClick() {
      setTab(1);
      setTabChangeLoader(true);
      setBigGallery(true);
      document.body.style.overflow = "hidden";
      trackEvents("view_360", helpers.getG4_data());
    }
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/360Blue.svg",
    alt: "icn"
  }), /*#__PURE__*/React.createElement("span", {
    className: "m-hide"
  }, t("view_360", {
    ns: "web_post_view"
  }))), videoObject && /*#__PURE__*/React.createElement("div", {
    className: [stl.playVideoButton, ""].join(" "),
    id: "play-video-button",
    onClick: function onClick() {
      setShowVideo(true);
      setTab(2);
      setTabChangeLoader(true);
      setBigGallery(true);
      document.body.style.overflow = "hidden";
    }
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/playBlue.svg",
    alt: "icn"
  }), /*#__PURE__*/React.createElement("span", {
    className: "m-hide"
  }, t("watch_video", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    className: ["m-show", stl.mobileDots].join(" "),
    id: "slider-dots-mobile"
  }, imagesSlides.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("span", {
      key: "pan" + idx,
      className: [idx == selectedIndex ? stl.activeOrnge : undefined, idx == selectedIndex + 3 ? stl.smalPanSlide : undefined, idx > selectedIndex + 3 ? stl.hidePan : undefined, idx == selectedIndex - 3 ? stl.smalPanSlide : undefined, idx < selectedIndex - 3 ? stl.hidePan : undefined].join(" ")
    });
  }))), bigGallery && props.inpectionNote && /*#__PURE__*/React.createElement("p", {
    className: stl.inpectionNote
  }, props.hasMultiNotes ? (_props$inpectionNote$ = props.inpectionNote[selectedIndex]) === null || _props$inpectionNote$ === void 0 ? void 0 : _props$inpectionNote$.note.split("-")[1] : props.inpectionNote.split("-")[1] ? props.inpectionNote.split("-")[1] : props.inpectionNote), bigGallery && imagesSlides.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: [stl.bigNumberSliderContainer].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.bigNumbering].join(" ")
  }, /*#__PURE__*/React.createElement("span", null, selectedIndex + 1), " ", /*#__PURE__*/React.createElement("span", {
    "data-dir": "rtl"
  }, "/"), /*#__PURE__*/React.createElement("span", {
    "data-dir": "ltr"
  }, "/"), " ", /*#__PURE__*/React.createElement("span", null, imagesSlides.length))), bigGallery && /*#__PURE__*/React.createElement("div", {
    className: [stl.thumbContainerNS, imagesSlides.length <= 9 ? stl.centerMe : undefined].join(" "),
    ref: thumbRef,
    id: "slider-thumbnails-container"
  }, imagesSlides.length > 1 && imagesSlides.map(function (item, idx) {
    return maxIteration >= idx && /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx + "thumb"
    }, /*#__PURE__*/React.createElement("div", {
      className: [stl.singlethumb, selectedIndex == idx ? stl.activethumb : undefined].join(" "),
      onClick: function onClick() {
        setSelectedIndex(idx);
      }
    }, /*#__PURE__*/React.createElement(CarImage, {
      alt: "car",
      src: props.thumbx683 ? item.props["data-mrk"] ? item.props["src"] : item.props["data-src"] : item.props["data-mrk"] ? item.props["src"].replace("x683", "x154").replace("x426", "x154").replace("x960", "x154").replace("x426", "x154") : item.props["data-src"].replace("x683", "x154").replace("x426", "x154").replace("x960", "x154").replace("x426", "x154")
    })));
  }))), (props === null || props === void 0 ? void 0 : props.showCamera360) && props.id360 && /*#__PURE__*/React.createElement("div", {
    className: [stl.container360Tab, Tab == 1 ? stl.show360Cont : undefined].join(" ")
  }, /*#__PURE__*/React.createElement(Camera360New, {
    id: props.id360,
    updateHas360: function updateHas360(val) {
      setHas360(val);
    }
  })), props.video && /*#__PURE__*/React.createElement("div", {
    style: {
      display: Tab != 2 ? "none" : ""
    }
  }, Tab == 2 && showVideo && videoObject && RenderVideoBasedOnUrl(videoObject.video_link)))));
};
export default NewPostBigSlider;